import { styled } from '@mui/material';
import React from 'react';
import ArrayUtil from 'utils/Array/Array.util';

const DEFAULT_LOADER_SIZE = 2;
const LOADER_DOTS = 9;

export interface Props {
  size?: number;
  id?: string;
}

const StyledLoader = styled('div')<Props>(
  ({ size = DEFAULT_LOADER_SIZE }) => `
  position: relative;
  width: ${size}em;
  height: ${size}em;
  margin: 0 auto;
`
);

interface BarProps {
  key: number;
  index: number;
}

const rotateDeg = 45;
const startingAnimationTime = -0.9;
const animationDivider = 10;

const StyledBar = styled('div')<Partial<BarProps>>(
  ({ theme, index }) => `
  @keyframes fade {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0.25;
    }
  }

  width: 6%;
  height: 16%;
  background-color: ${theme.palette.primary.main};
  position: absolute;
  left: 49%;
  top: 43%;
  opacity: 0;
  border-radius: 50%;
  animation-duration: .8s;
  animation-iteration-count: infinite;
  animation-name: fade;

  transform: rotate(${index! * rotateDeg}deg) translate(0, -130%);
  animation-delay: ${startingAnimationTime + index! / animationDivider}s;
`
);

const Loader: React.FC<React.PropsWithChildren<Props>> = ({ size = DEFAULT_LOADER_SIZE, id }) => (
  <StyledLoader size={size} data-testid="Loader" id={id || 'Loader'}>
    {ArrayUtil.Range(LOADER_DOTS).map((value) => (
      <StyledBar key={value} index={value} />
    ))}
  </StyledLoader>
);

export default Loader;
